<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :popupComponent="popupComponent"
        :basic-data="basicData"
        title="Method List"
        icon="mdi-cash-register"
        addButtonText="Method"
        stateendpoint="method.methods"
        :actions="actions"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";
import MethodPopup from "../components/popups/MethodPopup";

export default {
  name: 'Methods',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Methods | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage, MethodPopup},
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'name'},
        {value: 'isActive'},
        {value: 'action'},
      ],
      actions: {
        load: 'loadMethods',
        create: 'storeMethod',
        update: 'updateMethod',
        remove: 'destroyMethod',
        softDelete: 'methodSoftDeleteHandler',
      },
      basicData: {
        type: 'online',
        isActive: true
      }
    }
  },
  computed: {
    popupComponent() {
      return MethodPopup;
    }
  }
}
</script>
